import { Pipe, PipeTransform } from '@angular/core';

export type gendersT = 'female' | 'male' |  'Female' | 'Male' | 'other' | 'Other' |'unknow' | 'Unknow';
export type gendersTranslated = 'Feminino' | 'Masculino' | 'Outro';

@Pipe({
  name: 'translateGender'
})
export class TranslateGenderPipe implements PipeTransform {

  private genderMap: Record<gendersT, gendersTranslated> = {
    female: 'Feminino',
    Female: "Feminino",
    Male: "Masculino",
    male: 'Masculino',
    Other: "Outro",
    other: 'Outro',
    unknow: 'Outro', 
    Unknow: 'Outro', 
  };

  transform(value: gendersT): gendersTranslated {
    return this.genderMap[value] || 'Outro'; // Valor padrão caso não corresponda
  }
}
